module.exports = __webpack_public_path__ + "res/img/kc.8e2be227.png";